$(function () {
  const CountUp = require('countup.js');

  let statisticDiffIds = ['cars-statistic-views-diff', 'cars-statistic-leads-diff', 'motos-statistic-views-diff', 'motos-statistic-leads-diff', 'trucks-statistic-views-diff', 'trucks-statistic-leads-diff'];
  let statisticElements = {
    views: {
      cars: document.getElementById('cars-statistic-views'),
      motos: document.getElementById('motos-statistic-views'),
      trucks: document.getElementById('trucks-statistic-views')
    },
    leads: {
      cars: document.getElementById('cars-statistic-leads'),
      motos: document.getElementById('motos-statistic-leads'),
      trucks: document.getElementById('trucks-statistic-leads')
    }
  };

  function clearDiffCounter() {
    for (let i = 0; i < statisticDiffIds.length; i++) {
      let item = statisticDiffIds[i];
      document.getElementById(item).innerHTML = '';
    }
  }

  function recountViewsAndLeads(data) {
    for (const [statistic, elements] of Object.entries(statisticElements)) {
      let stat = statistic;
      for (const [carType, item] of Object.entries(elements)) {
        let newValue = data[stat][carType];
        let currentVelue = item.innerText;
        let numAnim = new CountUp(item, currentVelue, newValue);
        if (!numAnim.error) {
          numAnim.start();
        }
      }
    }
  }

  $('#statistic_period').on('change', function () {
    let $self = $(this);
    $.ajax({
      url: '/api/v1/dashboards/statistics',
      method: 'GET',
      data: {
        start_date: $self.val()
      },
      success: function (data) {
        clearDiffCounter();
        recountViewsAndLeads(data);
      }
    });
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/dashboard.js